export default class AuthDomainConfigRequiredError extends Error {
  constructor() {
    super("Authentication domain configuration is not provided.");
  }
}
